import { isSaasPlatformHost } from '../../share/serviceappBrand.js';

/** Hosts that serve the Tools & Bubbles marketing site (not ServiceApp tenant booking). */
export function isToolsAndBubblesProductionHost(host: string): boolean {
  const h = (host || '').toLowerCase();
  return h.includes('toolsandbubbles');
}

/** True when the hostname is a tenant custom booking domain (not serviceapp.ai or T&B). */
export function isLikelyTenantCustomDomainHost(host?: string): boolean {
  const h = (host ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  if (!h || h === 'localhost' || h === '127.0.0.1') return false;
  if (isSaasPlatformHost(h)) return false;
  if (isToolsAndBubblesProductionHost(h)) return false;
  return true;
}

/**
 * Hosts that can identify a public tenant without `?org=` — T&B production
 * plus other custom domains. Does not change Ava/marketing routing, which
 * still uses isLikelyTenantCustomDomainHost (T&B is not a "tenant custom domain").
 */
export function canResolvePublicOrgFromHost(host?: string): boolean {
  const h = (host ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  if (!h || h === 'localhost' || h === '127.0.0.1') return false;
  if (isSaasPlatformHost(h)) return false;
  return isToolsAndBubblesProductionHost(h) || isLikelyTenantCustomDomainHost(h);
}
